<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>

  <mat-card appearance="outlined" *ngIf="failedPackage">
    <div>PackageId: <span>{{failedPackage._id}}</span></div>
    <ng-container *ngIf="failedPackage.cache">
      <json-content-table [displayStyle]="'detail'" [json]="failedPackage.cache" [transformTimestamp]=true>
      </json-content-table>
    </ng-container>
  </mat-card>

</page-content>
